module.exports = __webpack_public_path__ + "static/media/heattread-1.d5cab0ae.jpg";